// src/components/leads/LeadInitialsBadge.tsx
// Small circle beside a lead's name: stage color plus two initials.
import React from 'react';
import { stagePillStyle } from './LeadStageBadge';
import { isUnassignedStage, NEW_LEAD_DOT_STYLE } from './pipelineStage';

export function leadInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}

interface LeadInitialsBadgeProps {
  name: string;
  stage?: string | null;
  stageColor?: string | null;
  size?: number;
}

const LeadInitialsBadge: React.FC<LeadInitialsBadgeProps> = ({
  name,
  stage,
  stageColor,
  size = 22,
}) => {
  const unassigned = isUnassignedStage(stage);
  const paint = unassigned ? NEW_LEAD_DOT_STYLE : stagePillStyle(stageColor, stage || '');
  return (
    <span
      className="inline-flex shrink-0 items-center justify-center rounded-full font-semibold leading-none"
      style={{
        width: size,
        height: size,
        fontSize: Math.max(8, Math.round(size * 0.38)),
        color: unassigned ? 'rgba(255,255,255,0.75)' : '#fff',
        ...paint,
      }}
      aria-hidden
    >
      {leadInitials(name)}
    </span>
  );
};

export default LeadInitialsBadge;
